var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-select-component',{attrs:{"id":_vm.id,"name":_vm.name,"options":_vm.options,"value":_vm.value,"keyColumn":"code","valueColumn":"code","descriptionColumn":"name"},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }